import { GLOBAL_SEARCH } from "api/endpoints";
import mxdApiInstance from "..";

export const GlobalSearchApi = {
  getSearchOptions: async (params) => {
    const response = mxdApiInstance.get(GLOBAL_SEARCH, { params });
    return response;
  },
};
